import { render } from "./ToolBar.vue?vue&type=template&id=f3564678"
import script from "./ToolBar.vue?vue&type=script&lang=js"
export * from "./ToolBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__